export default "/assets/images/cooking-video-thumbnail.jpg?557f833a39794f26d3fecc6e10195ea6";